import { supabase } from '../lib/supabase';

const toSnakeCase = (itemData) => ({
  item_name: itemData?.itemName || itemData?.name,
  category: itemData?.category,
  quantity: itemData?.quantity,
  unit: itemData?.unit,
  last_used: itemData?.lastUsed
});

const toCamelCase = (row) => ({
  id: row?.id,
  tripId: row?.trip_id,
  name: row?.item_name,
  itemName: row?.item_name,
  category: row?.category,
  quantity: row?.quantity,
  unit: row?.unit,
  lastUsed: row?.last_used,
  createdAt: row?.created_at,
  updatedAt: row?.updated_at
});

export const inventoryService = {
  async getInventoryByTrip(tripId) {
    try {
      const { data, error } = await supabase?.from('inventory')?.select('*')?.eq('trip_id', tripId)?.order('category', { ascending: true });
      
      if (error) throw error;
      
      return { data: data?.map(toCamelCase) || [], error: null };
    } catch (error) {
      return { data: [], error };
    }
  },

  async createInventoryItem(tripId, itemData) {
    try {
      const { data, error } = await supabase?.from('inventory')?.insert({
          trip_id: tripId,
          ...toSnakeCase(itemData)
        })?.select()?.single();
      
      if (error) throw error;
      
      return { data: toCamelCase(data), error: null };
    } catch (error) {
      return { data: null, error };
    }
  },

  async updateInventoryItem(itemId, itemData) {
    try {
      const { data, error } = await supabase?.from('inventory')?.update(toSnakeCase(itemData))?.eq('id', itemId)?.select()?.single();
      
      if (error) throw error;
      
      return { data: toCamelCase(data), error: null };
    } catch (error) {
      return { data: null, error };
    }
  },

  async deleteInventoryItem(itemId) {
    try {
      const { error } = await supabase?.from('inventory')?.delete()?.eq('id', itemId);
      
      if (error) throw error;
      
      return { error: null };
    } catch (error) {
      return { error };
    }
  },

  async bulkDeleteInventoryItems(itemIds) {
    try {
      const { error } = await supabase?.from('inventory')?.delete()?.in('id', itemIds);
      
      if (error) throw error;
      
      return { error: null };
    } catch (error) {
      return { error };
    }
  },

  async getRandomSnack(tripId) {
    try {
      const { data, error } = await supabase
        ?.from('inventory')
        ?.select('*')
        ?.eq('trip_id', tripId)
        ?.eq('category', 'Snack')
        ?.gt('quantity', 0);
      
      if (error) throw error;
      
      if (!data || data?.length === 0) {
        return { data: null, error: { message: 'No snacks available in inventory' } };
      }
      
      const randomIndex = Math.floor(Math.random() * data?.length);
      const randomSnack = data?.[randomIndex];
      
      return { data: toCamelCase(randomSnack), error: null };
    } catch (error) {
      return { data: null, error };
    }
  },

  async deleteAllInventoryByTrip(tripId) {
    try {
      const { error } = await supabase?.from('inventory')?.delete()?.eq('trip_id', tripId);
      
      if (error) throw error;
      
      return { error: null };
    } catch (error) {
      return { error };
    }
  }
};